// AIChatTestHarness.js
import React, { useState, useEffect } from 'react';
import { IonApp, IonContent, setupIonicReact } from '@ionic/react';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

import { AIChat } from './AIChat';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Initialize Ionic React
setupIonicReact();

const AIChatTestHarness = () => {
  // Get auth data from URL parameters
  const [authData, setAuthData] = useState({
    member_id: null,
    user_id: null,
    auth_token: null
  });

  useEffect(() => { 
    const member_id = '195';
    const user_id = '14';
    const auth_token = 'eyJhbGciOiJBMjU2S1ciLCJlbmMiOiJBMjU2Q0JDLUhTNTEyIiwiemlwIjoiREVGIn0.lK7P8NfNtT9JeyLLIDJS4mZwLsbQE8BNzGtJmv9KU72_NRU-HuoiuP-OQwckZY0Sk9uwN6ZhrXvpUnPf_MLlcq-zhh0GhDVo.AWi9-4LHOcSXv1cyONEZAw.P93TxCKm3_-5blCAXdnQ6xnZVK4j4t1LKvEyc7q9apx4V6PyeDQ9z9MtqH69H-cMzUsR7vwgv9qEbl6hS7sg2TBDrlGcsbvoB9gna3M4QZ62XQSg1HSLCIjt6OP_oihmS5Lf9TKTEk0YHoO9QmSUnlYDBF-hbliKE1XGoIn2zuw.kfJuZXNvCYIfIyz3w4GqqVBv301RZT_Z721EnguZsxM';

    if (member_id && user_id && auth_token) {
      setAuthData({ member_id, user_id, auth_token });
      // Store in localStorage as AIChat expects
      localStorage.setItem('member_id', member_id);
      localStorage.setItem('user_id', user_id);
      localStorage.setItem('auth_token', auth_token);
    }
  }, []);

  return (
    <IonApp>
      <IonContent>
        {authData.member_id && authData.user_id && authData.auth_token ? (
          <AIChat 
            member_id={authData.member_id}
            user_id={authData.user_id}
            auth_token={authData.auth_token}
          />
        ) : (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <h2>Missing Authentication Data</h2>
            <p>Please provide member_id, user_id, and auth_token as URL parameters.</p>
            <p>Example: ?member_id=123&user_id=456&auth_token=abc...</p>
          </div>
        )}
      </IonContent>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </IonApp>
  );
};

export default AIChatTestHarness;
